import { defineMessages } from 'react-intl';
export default defineMessages({
    default_header: {
        id: 'shared.ErrorPage.header',
        defaultMessage: 'Unable to Complete Action',
    },
    default_tip: {
        id: 'orders.ErrorPage.defaultTip',
        defaultMessage: 'Our system encountered an error while processing the request. Try the following troubleshooting steps: ',
    },
    default_tip_reload_app: {
        id: 'orders.ErrorPage.defaultTipReloadApp',
        defaultMessage: 'Reload the app or sign in again;',
    },
    default_tip_clear_cache: {
        id: 'orders.ErrorPage.defaultTipClearCache',
        defaultMessage: 'Clear your browser cache or try using incognito mode;',
    },
    default_tip_update_browser: {
        id: 'orders.ErrorPage.defaultTipUpdateBrowser',
        defaultMessage: 'Make sure your browser is up to date;',
    },
    default_tip_ios: {
        id: 'orders.ErrorPage.defaultTipIos',
        defaultMessage: "If you're using iOS, check if your version is still supported by Apple.",
    },
    default_tip_contact_ticketmaster: {
        id: 'orders.ErrorPage.defaultTipIos',
        defaultMessage: 'If the problem persists, contact your Ticketmaster representative for assistance.',
    },
    unauthorized_header: {
        id: 'shared.ErrorPage.header.unauthorized',
        defaultMessage: 'Unauthorized Access',
    },
    unauthorized_tip: {
        id: 'shared.ErrorPage.tip.unauthorized',
        defaultMessage: 'You do not have the necessary permissions to access this application.\nIf you require access, contact your administrator.',
    },
    reload_app: {
        id: 'shared.ErrorPage.reloadApp',
        defaultMessage: 'Reload App',
    },
    sign_in_again: {
        id: 'shared.ErrorPage.signInAgain',
        defaultMessage: 'Sign In Again',
    },
});
